import { api } from '@/api/client';

export function getProjectSessionsQueryOptions(projectId: string) {
  return {
    queryKey: ['projectSessions', projectId] as const,
    queryFn: () => api.sessions.list({ projectId }),
    staleTime: 5_000,
  };
}
